import { PureComponent, ReactNode } from 'react';
import { TreatmentPlan } from '../../../../../api/getTreatmentPlans';
import { Collapse } from 'antd';
import { ACTIVE_TAB } from './PPTreatmentPlan';
import ActiveTabPlan from './ActiveTabPlan';
import { Doctor } from '../../../../../store/types/prescription';
const { Panel } = Collapse;

interface Props {
    activeTabPlans: TreatmentPlan[];
    visibleItems?: Set<string>;
    onVisibleItemsChange: (key?: string) => void;
    activeTab: ACTIVE_TAB;
    onActivate: (treatmentPlan: TreatmentPlan) => Promise<void>;
    onEdit: (estimate: TreatmentPlan) => void;
    treatmentBillingModalToggleHandler: (
        treatmentPlan?: TreatmentPlan,
        isForWorkDone?: boolean,
    ) => void;
    className?: string;
    ptDetails: string;
    docProfile?: Doctor;
}

class EstimateAndCompletedPlan extends PureComponent<Props> {
    render(): ReactNode {
        const {
            activeTabPlans,
            visibleItems,
            onVisibleItemsChange,
            activeTab,
            onActivate,
            onEdit,
            treatmentBillingModalToggleHandler,
            className,
            ptDetails,
            docProfile,
        } = this.props;

        return (
            <div className={`flex-1 overflow-auto space-y-10 ${className ? className : ''}`}>
                {activeTabPlans.map((treatmentPlan) => {
                    return (
                        <ActiveTabPlan
                            visibleItems={visibleItems}
                            treatmentPlan={treatmentPlan}
                            onVisibleItemsChange={onVisibleItemsChange}
                            activeTab={activeTab}
                            onEdit={onEdit}
                            onActivate={onActivate}
                            treatmentBillingModalToggleHandler={treatmentBillingModalToggleHandler}
                            ptDetails={ptDetails}
                            docProfile={docProfile}
                        />
                    );
                })}
            </div>
        );
    }
}

export default EstimateAndCompletedPlan;
